import { forwardRef } from 'react'
import { Input, InputProps } from '@chakra-ui/react'
import { FormControl } from 'components'

type Props = InputProps & {
  label?: string
  helperText?: string
  isInvalid?: boolean
}

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ label, helperText, variant = 'outline', size = 'md', isInvalid = false, ...props }, ref) => {
    return (
      <FormControl label={label} helperText={helperText} error={isInvalid ? helperText : undefined}>
        <Input ref={ref} variant={variant} size={size} {...props} />
      </FormControl>
    )
  },
)

TextInput.displayName = 'TextInput'
